@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.notification.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mifos_mobile.feature.notification.generated.resources/"

internal val Res.drawable.ic_notifications: DrawableResource by lazy {
      DrawableResource("drawable:ic_notifications", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_notifications.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_notifications", Res.drawable.ic_notifications)
}
